import { SelectOption } from '.';

export const formatLabel =
  <T>(options: SelectOption<T>[]) =>
  (newValue: T): string | T =>
    options.find(({ value: optionValue }) => optionValue === newValue)?.label || newValue;
